export const getPublicGameTitle = (gameType = '') => {
  switch (gameType.toLowerCase()) {
    case 'lol':
      return '리그 오브 레전드';
    case 'valorant':
      return '발로란트';
    default:
      return '지원하지않는게임';
  }
};

export const GAME_TYPES = ['LOL', 'VALORANT'];
